import { customDateFormatWithTime, statusFormatterWithMap, textFormatter } from "components/Common/formatter";
import { PRICE_TYPES_OPTION, STATUS_COLOR_MAP } from "pages/price-management/Prices/variables";
import NGIDropdownButton from "components/Common/buttons/NGIDropdownButton";
import ButtonGroup from "components/Common/buttons/ButtonGroup";
import arrow from "assets/images/svg/arrow-white.svg";
import editCalendar from "assets/images/svg/Edit Calendar.svg";
import editPencil from "assets/images/svg/edit-pencil.svg";
import addCustomers from "assets/images/svg/add-customers.svg";
import { USER_ROLES } from "utils/constants";
import removeCustomers from "assets/images/svg/remove-customers.svg";
import React from "react";

export const pricesColumns = (styles, priceType, editItem, approveDecline) => {
  const generalFields = [
    {
      title: "Price Name",
      dataIndex: "name",
    },
    {
      title: "Status",
      dataIndex: "status",
      render: value => statusFormatterWithMap(value, STATUS_COLOR_MAP),
    },
    {
      title: "Type",
      dataIndex: "type",
      render: textFormatter,
    },
    {
      title: "Product ID",
      dataIndex: "id",
    },
    {
      title: "Product",
      dataIndex: "product",
      render: textFormatter,
    },
    {
      title: "Created at",
      dataIndex: "createdAt",
      render: cellContent => textFormatter(customDateFormatWithTime(cellContent)),
    },
    {
      title: "Created by",
      dataIndex: "createdBy",
      render: cellContent => (
        <div title={cellContent} className={styles.overflowText}>
          {cellContent}
        </div>
      ),
    },
  ];

  const actions = [
    {
      title: "",
      width: "4%",
      key: "action",
      render: (_, row) =>
        row.status !== "Expired" && (
          <NGIDropdownButton
            position="left"
            toggleEl={<ButtonGroup icon={arrow} />}
            menuItems={[
              ...(row.status === "Active"
                ? [
                    {
                      label: "Edit 'End' Date",
                      icon: editCalendar,
                      callback: () => editItem(row),
                    },
                  ]
                : []),
              ...(row.status === "New"
                ? [
                    {
                      label: "Edit Price",
                      icon: editPencil,
                      callback: () => editItem(row),
                    },
                  ]
                : []),
              ...(row.status === "Pending"
                ? [
                    {
                      label: "Approve Price",
                      icon: addCustomers,
                      callback: () => approveDecline(row, true),
                      roles: [USER_ROLES.SYSTEM_FULL_ADMINS, USER_ROLES.FINANCE],
                    },
                    {
                      label: "Decline Price",
                      icon: removeCustomers,
                      callback: () => approveDecline(row, false),
                      roles: [USER_ROLES.SYSTEM_FULL_ADMINS, USER_ROLES.FINANCE],
                    },
                  ]
                : []),
            ]}
          />
        ),
    },
  ];
  switch (priceType) {
    case PRICE_TYPES_OPTION.DEFAULT:
      return [
        ...generalFields,
        {
          title: "Registration Category",
          dataIndex: "registrationCategory",
          render: textFormatter,
        },
        {
          title: "Price Amount",
          dataIndex: "amount",
          render: textFormatter,
        },
        {
          title: "Active Period (From - to)",
          dataIndex: "activationDate",
          width: "20%",
          render: (_, row) =>
            row.activationDate ? `${row.activationDate} - ${row.deactivationDate || ""}` : textFormatter(),
        },
        ...actions,
      ];
    case PRICE_TYPES_OPTION.DEPOT:
      return [
        ...generalFields,
        {
          title: "Registration Category",
          dataIndex: "registrationCategory",
          render: textFormatter,
        },
        {
          title: "Price Option",
          dataIndex: "pricingOption",
          render: textFormatter,
        },
        {
          title: "Value",
          dataIndex: "amount",
          render: textFormatter,
        },
        {
          title: "Final Price",
          dataIndex: "actualAmount",
          render: textFormatter,
        },
        {
          title: "Depots",
          dataIndex: "depots",
          render: value => (value ? value?.join(", ") : textFormatter()),
        },
        {
          title: "Active Period (From - to)",
          dataIndex: "activationDate",
          width: "20%",
          render: (_, row) =>
            row.activationDate ? `${row.activationDate} - ${row.deactivationDate || ""}` : textFormatter(),
        },
        ...actions,
      ];
    case PRICE_TYPES_OPTION.CONSUMPTION_BAND:
      return [
        ...generalFields,
        {
          title: "Price Option",
          dataIndex: "pricingOption",
          render: textFormatter,
        },
        {
          title: "Value",
          dataIndex: "amount",
          render: textFormatter,
        },
        {
          title: "Final Price",
          dataIndex: "actualAmount",
          render: textFormatter,
        },
        {
          title: "Depots",
          dataIndex: "depots",
          render: value => (value ? value?.join(", ") : textFormatter()),
        },
        ...(priceType === PRICE_TYPES_OPTION.CONSUMPTION_BAND
          ? [
              {
                title: "Consumption Band",
                dataIndex: "consumptionBand",
                render: textFormatter,
              },
            ]
          : []),
        ...(priceType === PRICE_TYPES_OPTION.CUSTOMER_GROUP
          ? [
              {
                title: "Customer Group",
                dataIndex: "customerGroupName",
                render: textFormatter,
              },
            ]
          : []),
        {
          title: "Active Period (From - to)",
          dataIndex: "activationDate",
          width: "20%",
          render: (_, row) =>
            row.activationDate ? `${row.activationDate} - ${row.deactivationDate || ""}` : textFormatter(),
        },
        ...actions,
      ];
    case PRICE_TYPES_OPTION.CUSTOMER_GROUP:
      return [
        ...generalFields,
        {
          title: "Price Amount",
          dataIndex: "amount",
          render: textFormatter,
        },
        {
          title: "Depots",
          dataIndex: "depots",
          render: value => (value ? value?.join(", ") : textFormatter()),
        },
        ...(priceType === PRICE_TYPES_OPTION.CONSUMPTION_BAND
          ? [
              {
                title: "Consumption Band",
                dataIndex: "consumptionBand",
                render: textFormatter,
              },
            ]
          : []),
        ...(priceType === PRICE_TYPES_OPTION.CUSTOMER_GROUP
          ? [
              {
                title: "Customer Group",
                dataIndex: "customerGroupName",
                render: textFormatter,
              },
            ]
          : []),
        {
          title: "Active Period (From - to)",
          dataIndex: "activationDate",
          width: "20%",
          render: (_, row) =>
            row.activationDate ? `${row.activationDate} - ${row.deactivationDate || ""}` : textFormatter(),
        },
        ...actions,
      ];
    default:
      return [];
  }
};
